
import { motion } from 'framer-motion';

const TrackingFeature = () => {
  const features = [
    {
      icon: 'ri-map-pin-line',
      title: 'Live GPS Tracking',
      description: 'Monitor your shipments in real-time with precise location updates every step of the way.',
    },
    {
      icon: 'ri-route-line',
      title: 'Multi-Modal Support',
      description: 'Seamless tracking across ocean, air, road, and rail transport modes in one platform.',
    },
    {
      icon: 'ri-notification-3-line',
      title: 'Instant Notifications',
      description: 'Receive immediate alerts for every milestone, delay, or status change in your delivery.',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block px-4 py-2 bg-primary-blue/10 rounded-lg text-sm font-semibold text-primary-blue uppercase tracking-wider mb-6 whitespace-nowrap">
              Tracking Technology
            </div>
            <h2 className="font-heading text-4xl lg:text-5xl text-gray-900 font-bold mb-8">
              Track Your Shipments in Real-Time
            </h2>
            <div className="space-y-6">
              {features.map((feature, index) => (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex items-start space-x-4"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-blue rounded-xl flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
                    <p className="text-gray-600">{feature.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative bg-white rounded-xl shadow-2xl p-8 overflow-hidden">
              <div className="relative">
                <div className="bg-primary-blue rounded-xl p-6 mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-white/80 text-sm font-medium whitespace-nowrap">Tracking Number</span>
                    <span className="text-white font-mono font-semibold whitespace-nowrap">TRV-2024-8472</span>
                  </div>
                  <div className="bg-white/20 rounded-xl p-4">
                    <div className="flex items-center space-x-3 mb-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full">
                        <i className="ri-map-pin-fill text-primary-blue"></i>
                      </div>
                      <div>
                        <div className="text-white font-semibold whitespace-nowrap">In Transit</div>
                        <div className="text-white/70 text-sm whitespace-nowrap">Rotterdam, Netherlands</div>
                      </div>
                    </div>
                    <div className="w-full bg-white/30 rounded-full h-2">
                      <div className="bg-primary-green rounded-full h-2 w-2/3"></div>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="flex items-center space-x-4 p-4 bg-green-50 rounded-xl">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-green rounded-full">
                      <i className="ri-checkbox-circle-fill text-white"></i>
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-gray-900 whitespace-nowrap">Package Departed</div>
                      <div className="text-sm text-gray-600 whitespace-nowrap">Hamburg Port - 2 hours ago</div>
                    </div>
                  </div>

                  <div className="flex items-center space-x-4 p-4 bg-blue-50 rounded-xl">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-blue rounded-full">
                      <i className="ri-ship-line text-white"></i>
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-gray-900 whitespace-nowrap">Ocean Freight</div>
                      <div className="text-sm text-gray-600 whitespace-nowrap">Vessel: MSC Gülsün</div>
                    </div>
                  </div>

                  <div className="flex items-center space-x-4 p-4 bg-gray-100 rounded-xl opacity-50">
                    <div className="w-10 h-10 flex items-center justify-center bg-gray-400 rounded-full">
                      <i className="ri-map-pin-line text-white"></i>
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-gray-900 whitespace-nowrap">Arriving Soon</div>
                      <div className="text-sm text-gray-600 whitespace-nowrap">Ajaccio - Est. 6 hours</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TrackingFeature;
